import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { GendersParams } from './service';

export enum GendersActions {
  Failure = '[Catalogs Genders] Failure',
  Request = '[Catalogs Genders] Request',
  Success = '[Catalogs Genders] Success',
}

export const GendersFailure = createAction(GendersActions.Failure, props<{ error: HttpErrorResponse }>());

export const GendersRequest = createAction(GendersActions.Request, props<{ parameters?: GendersParams }>());

export const GendersSuccess = createAction(GendersActions.Success, props<{ data: ParameterResult[] }>());
